import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=9a14d36c&scoped=true&"
import script from "./VehicleForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=9a14d36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a14d36c",
  null
  
)

export default component.exports